import { render, staticRenderFns } from "./user-confirmation.vue?vue&type=template&id=bddb2618&scoped=true&"
import script from "./user-confirmation.vue?vue&type=script&lang=js&"
export * from "./user-confirmation.vue?vue&type=script&lang=js&"
import style0 from "./user-confirmation.vue?vue&type=style&index=0&id=bddb2618&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bddb2618",
  null
  
)

export default component.exports